// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.charts-page {
  display: flex;
  flex-direction: column;
  height: 75vh;
  padding: 16px;
  box-sizing: border-box;
}
.charts-page .page-title {
  margin-top: 0;
  margin-bottom: 20px;
  font-size: 1.25rem;
}
.charts-page .spinner-container {
  display: flex;
  justify-content: center;
  padding: 24px 0;
}
.charts-page .two-panel-layout {
  display: grid;
  grid-template-columns: minmax(280px, 580px) 1fr;
  gap: 24px;
  align-items: stretch;
  flex: 1 1 auto;
  min-height: 0;
}
.charts-page .left-panel,
.charts-page .right-panel {
  min-height: 0;
}
.charts-page .left-panel {
  border-right: 1px solid var(--p-surface-200, #e0e0e0);
  padding-right: 16px;
  overflow-y: auto;
}
.charts-page .right-panel {
  padding: 1rem;
}
.charts-page .chart-upload-panel {
  max-width: 480px;
}
.charts-page .chart-upload-panel h3 {
  margin-top: 0;
}
.charts-page .chart-upload-panel label {
  display: block;
  margin: 1rem 0 0.35rem;
  font-weight: 600;
}
.charts-page .chart-upload-panel input[type=text],
.charts-page .chart-upload-panel input[type=file] {
  display: block;
  width: 100%;
  box-sizing: border-box;
}
.charts-page .chart-upload-panel input[type=text] {
  padding: 0.5rem;
  border: 1px solid var(--p-surface-300, #c7c7c7);
  border-radius: 4px;
}
.charts-page .chart-upload-panel button {
  margin-top: 1rem;
}
.charts-page .selected-file {
  margin: 0.75rem 0 0;
  color: var(--p-text-muted-color, #666);
  overflow-wrap: anywhere;
}
.charts-page .upload-error {
  color: var(--p-red-600, #b42318);
  margin: 1rem 0 0;
}
.charts-page .chart-summary h3 {
  margin-top: 0;
}
.charts-page .empty-message {
  color: var(--p-text-muted-color, #888);
}`, "",{"version":3,"sources":["webpack://./src/app/pages/charts/charts-page.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;AACJ;AAEE;EACE,aAAA;EACA,uBAAA;EACA,eAAA;AAAJ;AAGE;EACE,aAAA;EACA,+CAAA;EACA,SAAA;EACA,oBAAA;EACA,cAAA;EACA,aAAA;AADJ;AAIE;;EAEE,aAAA;AAFJ;AAKE;EACE,qDAAA;EACA,mBAAA;EACA,gBAAA;AAHJ;AAME;EACE,aAAA;AAJJ;AAOE;EACE,gBAAA;AALJ;AAOI;EACE,aAAA;AALN;AAQI;EACE,cAAA;EACA,sBAAA;EACA,gBAAA;AANN;AASI;;EAEE,cAAA;EACA,WAAA;EACA,sBAAA;AAPN;AAUI;EACE,eAAA;EACA,+CAAA;EACA,kBAAA;AARN;AAWI;EACE,gBAAA;AATN;AAaE;EACE,mBAAA;EACA,sCAAA;EACA,uBAAA;AAXJ;AAcE;EACE,gCAAA;EACA,gBAAA;AAZJ;AAeE;EACE,aAAA;AAbJ;AAgBE;EACE,sCAAA;AAdJ","sourcesContent":[".charts-page {\n  display: flex;\n  flex-direction: column;\n  height: 75vh;\n  padding: 16px;\n  box-sizing: border-box;\n\n  .page-title {\n    margin-top: 0;\n    margin-bottom: 20px;\n    font-size: 1.25rem;\n  }\n\n  .spinner-container {\n    display: flex;\n    justify-content: center;\n    padding: 24px 0;\n  }\n\n  .two-panel-layout {\n    display: grid;\n    grid-template-columns: minmax(280px, 580px) 1fr;\n    gap: 24px;\n    align-items: stretch;\n    flex: 1 1 auto;\n    min-height: 0;\n  }\n\n  .left-panel,\n  .right-panel {\n    min-height: 0;\n  }\n\n  .left-panel {\n    border-right: 1px solid var(--p-surface-200, #e0e0e0);\n    padding-right: 16px;\n    overflow-y: auto;\n  }\n\n  .right-panel {\n    padding: 1rem;\n  }\n\n  .chart-upload-panel {\n    max-width: 480px;\n\n    h3 {\n      margin-top: 0;\n    }\n\n    label {\n      display: block;\n      margin: 1rem 0 0.35rem;\n      font-weight: 600;\n    }\n\n    input[type='text'],\n    input[type='file'] {\n      display: block;\n      width: 100%;\n      box-sizing: border-box;\n    }\n\n    input[type='text'] {\n      padding: 0.5rem;\n      border: 1px solid var(--p-surface-300, #c7c7c7);\n      border-radius: 4px;\n    }\n\n    button {\n      margin-top: 1rem;\n    }\n  }\n\n  .selected-file {\n    margin: 0.75rem 0 0;\n    color: var(--p-text-muted-color, #666);\n    overflow-wrap: anywhere;\n  }\n\n  .upload-error {\n    color: var(--p-red-600, #b42318);\n    margin: 1rem 0 0;\n  }\n\n  .chart-summary h3 {\n    margin-top: 0;\n  }\n\n  .empty-message {\n    color: var(--p-text-muted-color, #888);\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
